import { useEffect } from "react";
import LogRocket from "logrocket";

export default function LogRocketInit() {
  useEffect(() => {
    const isClient = typeof window !== "undefined";
    const isProduction = process.env.NODE_ENV === "production";
    const logRocketId = process.env.REACT_APP_LOG_ROCKET_PROJECT;
    if (isClient && isProduction && logRocketId) {
      LogRocket.init(logRocketId);
      console.log("LogRocket initialized.");

      // Extract UTM params
      const params = new URLSearchParams(window.location.search);
      const utmSource = params.get("utm_source") || "none";
      const utmMedium = params.get("utm_medium") || "none";
      const utmCampaign = params.get("utm_campaign") || "none";
      const utmTerm = params.get("utm_term") || "none";
      const utmContent = params.get("utm_content") || "none";

      LogRocket.identify("App User", {
        userType: "App Page",
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign,
        utm_term: utmTerm,
        utm_content: utmContent,
      });

      // Capture unhandled errors
      window.addEventListener("error", (event) => {
        console.error("Unhandled error:", event.error);
        LogRocket.captureException(event.error);
      });

      // Capture unhandled promise rejections
      window.addEventListener("unhandledrejection", (event) => {
        console.error("Unhandled promise rejection:", event.reason);
        LogRocket.captureException(event.reason);
      });
    } else {
      console.warn("LogRocket not initialized. Conditions not met.");
    }
  }, []);

  return null;
}
